@if (isUserRetrieved && isPwToChange) {
  <user-change-password [user] = "user" (onChangePassword)="onChangePassword()"></user-change-password>
}
@if (!isPwToChange && !isConfirmed && isUserRetrieved && isTenantsRetrieved && !isNoTenantAssigned) {
  <confirm-user [user] = "user" [userTenants] = "userTenants" [showProfile] = false (onChangeUser)="onChange(user)"></confirm-user>
}
@if (!isPwToChange && isConfirmed) {
  <select-tenant></select-tenant>
}
@if (!isPwToChange && isNoTenantAssigned) {
  <div>
    <br><br>
    <span style="padding-left:20px"><b>Kein Mandant und keine Projekte mehr zugeordnet!</b></span>
  </div>
}

